module.exports = __webpack_public_path__ + "static/media/awakenings.a0b1ebec.jpg";